module.exports = __webpack_public_path__ + "img/5.b01e77a7.png";